import { CircularProgress } from "@material-ui/core";
import queryString from "query-string";
import React, { Component } from "react";
import { connect } from "react-redux";
import { getContracts } from "../actions";
import ContractReportContent from "./components/ContractReportContent";

class ContractReportJustOpened extends Component {
  state = {
    loading: true,
    dataList: [],
    title: "",
  };

  componentDidMount() {
    const urlParams = queryString.parse(this.props.location.search);
    const onlyMyClients = this.props.location.state?.onlyMyClients;
    const isContractManager = this.props.location.state?.isContractManager;
    const params = {
      phase: ["WAITING_APORT", "WAITING_SIGN"],
      taxResidence: urlParams.taxResidence,
    };
    if (onlyMyClients) {
      params.consultantId = this.props.currentUser.id;
      params.hideOwnContracts = true;
    }
    if (isContractManager) {
      params.isContractManager = true;
      params.hideOwnContracts = true;
    }

    getContracts(params).then((dataList) => {
      // Filtro para eliminar contratos "bugados", que possuem amount zerado.
      dataList = dataList.filter((c) => c.amount == 0);
      this.setState({ dataList, loading: false });
    });
    this.setState({ title: `app.contracts.justopened${params.taxResidence ? "." + params.taxResidence : ""}`, taxResidence: params.taxResidence });
  }

  render() {
    const { loading, dataList } = this.state;
    const onlyMyClients = this.props.location.state?.onlyMyClients;
    const isContractManager = this.props.location.state?.isContractManager;
    if (loading) return <CircularProgress style={{ marginTop: "25%" }} />;
    return (
      <ContractReportContent
        title={this.state.title}
        dataList={dataList}
        desc={"justopened"}
        taxResidence={this.state.taxResidence}
        onlyMyClients={onlyMyClients}
        isContractManager={isContractManager}
        urlToBack={"/contractReportJustOpened"}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.user.user.me,
  };
}

export default connect(mapStateToProps)(ContractReportJustOpened);
